var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGreencheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 139.757,
    height: 139.757,
    viewBox: "0 0 139.757 139.757",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "download_16_",
    "data-name": "download (16)",
    transform: "translate(-164.461 -162.888)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_238",
    "data-name": "Path 238",
    d: "M275.6,224.98a49.037,49.037,0,1,0,49.037,49.037A49.069,49.069,0,0,0,275.6,224.98Zm-5.429,73.906-21.716-22.066,7-7,14.71,14.886,32.575-32.048,7,7Zm10.158.875-2.278-2.451L310.1,265.262l2.276,2.276Z",
    transform: "translate(-41.431 -41.426)",
    fill: "#019d01"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_239",
    "data-name": "Path 239",
    d: "M304.218,233.117c0-4.379-7.705-8.057-8.406-12.26-.876-4.379,4.9-10.507,3.327-14.536s-10.158-4.553-12.609-8.057c-2.452-3.678.525-11.559-2.452-14.71s-11.034-.176-14.71-2.627c-3.5-2.452-3.853-11.034-7.881-12.609-4.028-1.751-10.333,4.028-14.536,3.153s-7.705-8.582-12.26-8.582c-4.379,0-8.057,7.705-12.26,8.406-4.379.876-10.507-4.9-14.536-3.327s-4.553,10.158-8.057,12.609c-3.678,2.452-11.559-.525-14.71,2.452s-.176,11.034-2.627,14.71c-2.452,3.5-11.034,3.853-12.609,7.881-1.751,4.028,4.028,10.333,3.153,14.536s-8.582,7.705-8.582,12.26c0,4.379,7.705,8.057,8.406,12.26.876,4.379-4.9,10.507-3.327,14.536s10.158,4.553,12.609,8.057c2.452,3.678-.525,11.559,2.452,14.71s11.034.176,14.71,2.627c3.5,2.452,3.853,11.034,7.881,12.609,4.028,1.751,10.333-4.028,14.536-3.153s7.705,8.582,12.26,8.582c4.379,0,8.057-7.705,12.26-8.406,4.379-.876,10.507,4.9,14.536,3.327s4.553-10.158,8.057-12.609c3.678-2.452,11.559.525,14.71-2.452s.176-11.034,2.627-14.71c2.452-3.5,11.034-3.853,12.609-7.881,1.751-4.028-4.028-10.333-3.153-14.536.7-4.38,8.582-7.882,8.582-12.26Zm-70.052,51.836a52.366,52.366,0,1,1,52.366-52.366,52.4,52.4,0,0,1-52.366,52.366Z",
    transform: "translate(0 0)",
    fill: "#019d01"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreencheck);
export default __webpack_public_path__ + "static/media/greencheck.ad25ebe2234f2a9d65a2924d85e9c5e2.svg";
export { ForwardRef as ReactComponent };